import React from 'react';
import { Card } from 'antd';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import ManageLoans from './ManageLoans';

const ManageLoansPage = () => {
    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    return (
        <>
            <PageTitle title='Back' />
            <Card title="Manage Loans (Admin/HR)">
                <ManageLoans />
            </Card>
        </>
    );
};

export default ManageLoansPage;
